import React, { useEffect } from 'react'
import { Formik } from 'formik'
import ActionButtons from 'components/common/ActionButtons'
import deepEqual from 'deep-equal'

import Box from '@mui/material/Box'

import { generateAddressModalProps } from 'utils/smartyStreets'

import AddressForm from './AddressForm'
import { addressKeys, validationSchemas } from './AddressForm'

import useModal from 'hooks/context/useModal'

import { DELIVERY_TYPES } from 'utils/constants'
import FooterButtons from './FooterButtons'
import usePostingNoticeRequestContext from 'hooks/posting_notice_request/usePostingNoticeRequestContext'
import isEmptyObject from 'helpers/node/isEmptyObject'

function DeliveryAddress({
  activeIndex,
  disableEmail,
  headerActionProps,
  compact,
}) {
  return (
    <>
      {!disableEmail && (
        <Box sx={{ pb: 6 }}>
          <ActionButtons actionProps={headerActionProps} />
        </Box>
      )}
      <AddressForm activeIndex={activeIndex} compact={compact} />
    </>
  )
}

const initialValues = [
  {
    company_name: '',
    name: '',
    address_line_1: '',
    address_line_2: '',
    address_line_3: '',
    address_line_4: '',
    city: '',
    state: '',
    zip_code: '',
    country: 'USA',
  },
  {
    name: '',
    email: '',
  },
]

function DeliveryAddressWrapper({
  onNext,
  disableEmail,
  compact,
  footerButtonProps,
}) {
  const { shippingAddress, mailType, setMailType } =
    usePostingNoticeRequestContext()
  const { setOpen, setModalProps, setComponent: setModalComponent } = useModal()

  const headerActionProps = [
    {
      children: 'Mail',
      active: mailType === DELIVERY_TYPES.MAIL ? 'true' : undefined,
      onClick: () => setMailType(DELIVERY_TYPES.MAIL),
    },
    {
      children: 'Email',
      active: mailType === DELIVERY_TYPES.EMAIL ? 'true' : undefined,
      onClick: () => setMailType(DELIVERY_TYPES.EMAIL),
      disabled: disableEmail,
    },
  ].filter((b) => b)

  const handleSubmit = async (values) => {
    const onContinue = (newValues) => {
      setOpen(false)
      onNext?.(Array.isArray(newValues) ? newValues[0] : newValues)
    }

    const onCancel = () => setOpen(false)

    if (mailType === DELIVERY_TYPES.MAIL) {
      if (deepEqual(shippingAddress, values)) {
        onNext?.(values)
        return
      }

      const { modalProps, component } = await generateAddressModalProps({
        values,
        addressKeys,
        onContinue,
        onCancel,
      })

      setModalProps(modalProps)
      if (component) {
        setModalComponent(component)
      }

      setOpen(true)
    } else {
      onContinue(values)
    }
  }

  useEffect(() => {
    if (shippingAddress?.email && !disableEmail) {
      setMailType(DELIVERY_TYPES.EMAIL)
    } else {
      setMailType(DELIVERY_TYPES.MAIL)
    }
  }, [shippingAddress])

  return (
    <Formik
      initialValues={
        isEmptyObject(shippingAddress)
          ? initialValues[mailType]
          : shippingAddress
      }
      initialTouched={{ country: true }}
      onSubmit={handleSubmit}
      validationSchema={validationSchemas[mailType]}
      enableReinitialize
    >
      <Box>
        <DeliveryAddress
          activeIndex={mailType}
          setActiveIndex={setMailType}
          headerActionProps={headerActionProps}
          compact={compact}
          disableEmail={disableEmail}
        />
        <FooterButtons activeIndex={mailType} {...footerButtonProps} />
      </Box>
    </Formik>
  )
}

export default DeliveryAddressWrapper
